import React from 'react';
import ContactTCPACompliance from './TcpaComplianceDisplay/index.js';
import TermsAndConditions from './TermsAndConditionsDisplay/index.js';

var QuestionDisplayComponents = function QuestionDisplayComponents(_ref) {
  var displayComponents = _ref.displayComponents;
  return React.createElement(React.Fragment, null, displayComponents.map(function (displayComponent, idx) {
    switch (displayComponent.__typename) {
      case 'TcpaComplianceQuestionsDisplayComponentPathNodeFlowViewModel':
        return React.createElement(ContactTCPACompliance, {
          key: idx
        });

      case 'TermsAndConditionsQuestionsDisplayComponentPathNodeFlowViewModel':
        return React.createElement(TermsAndConditions, {
          key: idx
        });

      default:
        return null;
    }
  }));
};

export default QuestionDisplayComponents;
//# sourceMappingURL=index.js.map
